import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import ForegroundIcon from '../../../../../../icons/ForegroundIcon';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerForegroundControlsButton = ({
  className,
  onClick,
  active,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<ForegroundIcon />}
      title="Foreground"
      onClick={onClick}
    />
  );
};

CardDesignerForegroundControlsButton.propTypes = propTypes;

export default CardDesignerForegroundControlsButton;
